import { render, staticRenderFns } from "./shorts-message.vue?vue&type=template&id=3666cd1e&scoped=true"
import script from "./shorts-message.vue?vue&type=script&lang=js"
export * from "./shorts-message.vue?vue&type=script&lang=js"
import style0 from "./shorts-message.vue?vue&type=style&index=0&id=3666cd1e&prod&lang=scss&scoped=true"
import style1 from "./shorts-message.vue?vue&type=style&index=1&id=3666cd1e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3666cd1e",
  null
  
)

export default component.exports